import { AssetVizColorProps } from 'features/assetViz/defines'
import React from 'react'
import { useGeckoTheme } from 'styles/GeckoTheme'

/**
 * A hook which extracts colors from provided properties and memoizes them to
 * prevent frequent refreshes.
 * @param props           AssetViz props (this hook will only use a subset)
 * @param invertColors    Whether to invert colors or not (for screenshot mode)
 */
export const useExtractColors = (
  props: AssetVizColorProps,
  invertColors: boolean
) => {
  //----------------------------------------------------------------------------

  // This memoization is required since "theme" is regenerated all the time
  const { theme } = useGeckoTheme()
  return React.useMemo(
    () => ({
      assetColorString: invertColors
        ? theme.forecast.activeText
        : (props.assetColor ?? theme.forecast.background3),
      weldColorString: theme.forecast.secondaryText,
      corrosionRegionColorString:
        theme.forecast.activeText ?? theme.forecast.secondaryText,
      featureLabelColorString: invertColors
        ? theme.forecast.background1
        : theme.forecast.activeText,
      gridColorString: props.gridColor ?? theme.forecast.defaultText,
      draftSelectionColorString:
        props.outlineColor ?? theme.forecast.secondaryText,
      selectionColorString: props.outlineColor ?? theme.forecast.border,
      backgroundColorString: invertColors
        ? theme.forecast.activeText
        : (props.backgroundColor ?? ''),
      labelBackgroundColorString: invertColors
        ? theme.forecast.defaultText
        : theme.forecast.background2,
    }),
    [
      props.assetColor,
      props.backgroundColor,
      props.gridColor,
      props.outlineColor,
      invertColors,
      theme.forecast,
    ]
  )
}
